var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49935 1.56934C6.64352 1.56934 5.13477 3.07809 5.13477 4.93392C5.13477 6.75434 6.55852 8.22767 8.41435 8.29142C8.47102 8.28434 8.52768 8.28434 8.57018 8.29142C8.58435 8.29142 8.59143 8.29142 8.6056 8.29142C8.61268 8.29142 8.61268 8.29142 8.61977 8.29142C10.4331 8.22767 11.8568 6.75434 11.8639 4.93392C11.8639 3.07809 10.3552 1.56934 8.49935 1.56934Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0987 10.1756C10.1224 8.85812 6.89951 8.85812 4.90909 10.1756C4.00951 10.7777 3.51367 11.5923 3.51367 12.4635C3.51367 13.3348 4.00951 14.1423 4.90201 14.7373C5.89367 15.4031 7.19701 15.736 8.50034 15.736C9.80367 15.736 11.107 15.4031 12.0987 14.7373C12.9912 14.1352 13.487 13.3277 13.487 12.4494C13.4799 11.5781 12.9912 10.7706 12.0987 10.1756Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.41126364ee109cafd66a1ce8cbc5685d.svg";
export { ForwardRef as ReactComponent };